import { useEffect, useState } from "react";
import DashboardLayoutMain from "../../../layout/dashboard/DashboardLayoutMain";
import { useNavigate } from "react-router";
import { ALL_ROUTES } from "../../../routes/AllRoutes";
import { useDispatch, useSelector } from "react-redux";
import RootState from "../../../redux/type";
import { RazorTable, RazorTableRow } from "../../../components/razor-reuse";
import PaginationFragment from "../../../components/fragment/pagination/PaginationFragment";
import TextColorFragment from "../../../components/fragment/text-color/TextColorFragment";
import { formatTime } from "../../../utils/Helper";
import { getAppVersions, getNpsUserRecord } from "../../../redux/report";

const headerList = [
  "Full Name",
  "Email Address",
  "Score (0-10)",
  "App Version",
  "Device",
  "Date & Time",
];

const allLabel = { label: "All", value: "" };

const scoreOption = [
  { label: "0-4 (Detractors)", value: "0_4" },
  { label: "5-7 (Passives)", value: "5_7" },
  { label: "8-10 (Promoters)", value: "8_10" },
  { label: "All", value: "" },
];

const deviceOption = [
  { label: "Android", value: "android" },
  { label: "IOS", value: "ios" },
  { label: "All", value: "" },
];

// categorize the color of the score range text
const getScoreRangeColor = (val: number) => {
  if (val >= 0 && val <= 4) {
    // Detractors
    return "#F76659";
  } else if (val >= 5 && val <= 7) {
    // Passives
    return "#EFBF04";
  } else if (val >= 8 && val <= 10) {
    // Promoters
    return "#009933";
  } else {
    return "#162238";
  }
};

export default function ReportDetails() {
  const cust_id = localStorage?.getItem("cors_key") || "";
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { app_versions, loading_nps_record, nps_user_record } = useSelector(
    (state: RootState) => state.report,
  ); // for report

  const [filter, setFilter] = useState({
    page: 1,
    search: "",
    score_range: { label: "Score Range", value: "" },
    device: { label: "Device Type", value: "" },
    app_version: { label: "App Version", value: "" },
    date: "",
  });

  // get app versons
  useEffect(() => {
    dispatch(getAppVersions() as any);
  }, []);

  useEffect(() => {
    const payload = {
      page: filter.page,
      search: filter.search,
      score_min: filter.score_range?.value?.split("_")?.[0],
      score_max: filter.score_range?.value?.split("_")?.[1],
      device: filter.device?.value,
      app_version: filter.app_version?.value,
      from_date: filter?.date?.split(",")?.[0],
      to_date: filter?.date?.split(",")?.[1],
    };
    const body = { id: cust_id, param: payload };

    if (cust_id) {
      // fetch details of the customer using cust_id
      dispatch(getNpsUserRecord(body) as any);
    } else {
      navigate(ALL_ROUTES?.DASHBOARD_REPORT);
    }
  }, [dispatch, filter]);

  // creating app versions options
  const appVersionOptions =
    app_versions.map((version: string) => ({
      label: version,
      value: version,
    })) || [];

  return (
    <DashboardLayoutMain
      loading={false}
      back
      onBack={() => navigate(-1)}
      title="Reports"
    >
      <section className="px-[2rem] space-y-4 mt-[15px]">
        <div className="bg-white min-h-[90px] px-[26px] flex items-center mb-[30px]">
          <p className="font-semibold text-[18px] text-[#252C32]">
            {!loading_nps_record &&
              `${nps_user_record?.data?.[0]?.user?.first_name} ${nps_user_record?.data?.[0]?.user?.last_name} `}
            NPS History
          </p>
        </div>
        {/* filter section start */}
        {/* Currently not filtering the data for now since nps record can't pass 10 times in a year */}
        {/* <FilterReusableComp
          defaultSelectOne="Score range"
          className="mb-[15px]"
          selectOneValue={filter.score_range}
          selectOneList={scoreOption}
          onSelectOne={(param) => {
            setFilter((prev) => ({ ...prev, score_range: param }));
          }}
          onSearch={(param: any) => {
            setFilter((prev) => ({ ...prev, search: param, page: 1 }));
          }}
          selectTwoValue={filter.app_version}
          // formatOptionLabelTwo={formatOptionLabelTwo}
          defaultSelectTwo="App Version"
          selectTwoList={[...appVersionOptions, allLabel]}
          onSelectTwo={(param) => {
            setFilter((prev) => ({ ...prev, app_version: param }));
          }}
          searchPlaceholder="Search for username, email address"
          hideExport
          moreComponents={
            <>
              <DateRangeComponent
                onSet={(param) => {
                  setFilter((prev) => ({ ...prev, date: param }));
                }}
                value={filter.date}
                onCancel={() => {
                  setFilter((prev) => ({ ...prev, date: "" }));
                }}
                // onOpen={}
              />
              <RazorInputField
                color="black-light"
                className={`select-input ${"select-input-one"}`}
                type="select"
                placeholder="Device Type"
                value={filter.device}
                style={
                  {
                    "--select-width-one": "max-content",
                  } as React.CSSProperties
                }
                onChange={(param: any) => {
                  setFilter((prev) => ({ ...prev, device: param }));
                }}
                selectOption={deviceOption}
              />
              <div onClick={() => {}} className="export-box-wrap">
                <div className="icon-box">
                  <figure className="img-box">
                    {ALL_ICONS?.export_down_icon}
                  </figure>
                </div>
                <p className="text">{`Export`}</p>
              </div>
            </>
          }
        /> */}

        <RazorTable tableStrip={true} headerList={headerList}>
          {nps_user_record?.data?.map((chi: any, idx: number) => {
            return (
              <RazorTableRow
                onRowClick={() => {
                  // if (user?.permissions?.includes(systemRoles[14])) {
                  localStorage?.setItem("cors_key", chi?.id);
                  navigate(ALL_ROUTES?.DASHBOARD_REPORT_HISTORY);
                  // }
                }}
                loading={loading_nps_record}
                key={chi?.id}
                one={`${chi?.user?.first_name ?? "---"} ${
                  chi?.user?.last_name ?? "---"
                }`}
                two={chi?.user?.email ?? "---"}
                three={
                  <TextColorFragment
                    color={getScoreRangeColor(chi?.score)}
                    text={String(chi?.score)}
                  />
                }
                four={chi?.app_version ?? "---"}
                five={chi?.device_type ?? "---"}
                six={formatTime(chi?.created_at)}
              />
            );
          })}
        </RazorTable>

        <PaginationFragment
          currentPage={nps_user_record?.meta?.current_page}
          perPage={10}
          totalPage={nps_user_record?.meta?.total}
          onPageChange={(num) => {
            setFilter((prev) => ({ ...prev, page: num }));
          }}
          hidePagination={loading_nps_record}
        />
      </section>
    </DashboardLayoutMain>
  );
}
